import React, { useEffect, useState } from "react";
import { TimeoutWarningModal } from "./TimeoutWarningModal"
import { addEventListeners, removeEventListeners } from './eventListenerUtil'
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { logOut} from "../store/actions/CommonAction";
import RemoveCookie from '../utils/removeCookie';

export const TimeoutLogic = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  useEffect(() => {
    const createTimeout1 = () => setTimeout(() => {
      setWarningModalOpen(true);
      sessionStorage.removeItem('sessionId');
      window.location.href = '/login';
    }, 900000) // timmer

    const createTimeout2 = () => setTimeout(async() => {
      RemoveCookie('usrin');
      //await dispatch(logOut())
      //localStorage.clear();
      sessionStorage.removeItem('sessionId');
      window.location.href = '/login';
      //window.location.reload();
    }, 900000)

    const listener = () => {
      if (!isWarningModalOpen) {
        clearTimeout(timeout)
        timeout = createTimeout1();
      }
    }

    // Initialization
    let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1()
    addEventListeners(listener);

    // Cleanup
    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
    }
  }, [isWarningModalOpen])
  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal
          isOpen={isWarningModalOpen}
          onRequestClose={() => setWarningModalOpen(false)}
        />
      )
      }
    </div>
  )
}